import { useConfig } from "@jti/app-context/useConfig";
import type { FeatureFlags } from "@jti/fe-common";

export const useFeatureFlags = (): Required<FeatureFlags> => {
  const { featureFlags } = useConfig();

  return {
    ffCheckoutV2EnableIteration2: Boolean(featureFlags?.ffCheckoutV2EnableIteration2),
    ffCheckoutV2EnableIteration3: Boolean(featureFlags?.ffCheckoutV2EnableIteration3),
    ffFreeShippingProgressBar: Boolean(featureFlags?.ffFreeShippingProgressBar),
    ffNewMiniCartEnable: Boolean(featureFlags?.ffNewMiniCartEnable),
  };
};
